// extracted by mini-css-extract-plugin
export var active = "_dr-2";
export var recordingDot = "_dr-1";
export var recordingIndicator = "_dr-0";